import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';
import {classy} from 'webapp-lib/utils';

import {NOT_FOUND} from '_/utilities/string';

type Props = {
  children?: React.ReactNode | undefined;
  disabled?: boolean;
} & React.TableHTMLAttributes<HTMLTableCellElement>;

const UFieldValue = ({
  className,
  children,
  disabled,
  ...props
}: Props): React.ReactElement => (
  <StyledFieldValue
    {...props}
    className={classy({
      [className ?? '']: Boolean(className),
      FieldValue: true,
      disabled: Boolean(disabled),
    })}
  >
    {!children ? NOT_FOUND : children}
  </StyledFieldValue>
);

export const FieldValue = observer(UFieldValue);

const StyledFieldValue = styled.td`
  grid-area: value;
  color: var(--color-core-black);
  word-break: break-word;
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  white-space: break-spaces;

  &.disabled {
    color: var(--color-core-dark-grey);
  }

  a {
    color: unset;
  }

  img {
    min-width: 100%;
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
    object-fit: cover;
  }
`;
